import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  SuiModalService,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { CompanyService } from '../../services';
import { YearRecordModal } from '../year-record-modal/year-record-modal.component';
interface IEditEquipmentModalContext {
  data: any;
  title?: string;
  isEdit?: boolean;
}
@Component({
  selector: 'app-edit-equipment-modal',
  templateUrl: './edit-equipment-modal.component.html',
  styleUrls: ['./edit-equipment-modal.component.scss'],
})
export class EditEquipmentModalComponent implements OnInit, OnDestroy {
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;

  companyEquipmentForm: FormGroup;
  companyEquipment: any;
  constructor(
    private companySvc: CompanyService,
    private modalService: SuiModalService,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<IEditEquipmentModalContext, void, void>
  ) {
    this.companyEquipmentForm = fb.group({
      equipModelNumber: ['', Validators.required],
      equipName: ['', Validators.required],
      yearOfManufacture: ['', Validators.required],
      equipTypeId: ['', Validators.required],
      organizationId: [''],
    });
    if (modal.context.isEdit) {
      this.companyEquipment = modal.context.data;
      this.companyEquipmentForm.patchValue(modal.context.data);
    }
  }
  isFieldValid(field: string) {
    return (
      (!this.companyEquipmentForm.get(field).valid &&
        this.companyEquipmentForm.get(field).touched) ||
      (this.companyEquipmentForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }
  submit() {
    this.modal.context.isEdit == true ? this.update() : this.save();
  }

  save() {
    this.formSubmitAttempt = false;
    if (this.companyEquipmentForm.valid) {
      this.pending = true;
      this.companySvc
        .addCompanyEquipment({ body: this.companyEquipmentForm.value })
        .subscribe(
          (res) => {
            this.pending = false;
            this.success = 'Company equipment added successfully';
            setTimeout(() => {
              this.modal.approve(null);
            }, 2000);
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage ? error.error.errorMessage
                                                  : error.error ? error.error
                                                  : error;
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  update() {
    this.formSubmitAttempt = false;
    if (this.companyEquipmentForm.valid) {
      this.pending = true;
      this.companySvc
        .updateCompanyEquipment({
          id: this.companyEquipment.organizationEquipmentId,
          body: {
            ...this.companyEquipment,
            ...this.companyEquipmentForm.value,
          },
        })
        .subscribe(
          (res) => {
            this.pending = false;
            this.success = 'Company equipment updated successfully';
            setTimeout(() => {
              this.modal.approve(null);
            }, 2000);
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage ? error.error.errorMessage
                                                  : error.error ? error.error
                                                  : error;
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }
  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }

  yearRecord() {
    this.modalService
      .open(
        new YearRecordModal(
          'Year Records',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }
}

export class EditEquipmentModal extends ComponentModalConfig<
  IEditEquipmentModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(EditEquipmentModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
